import React, { TextareaHTMLAttributes } from 'react';
import classnames from 'classnames';
import omit from 'lodash/omit';
import useDebouncedInput from 'utils/useDebouncedInput';
import { clearClassName } from 'utils/string';

import './TextArea.scss';
import Tippy from '@tippyjs/react';

const cbn = 'form-text-area';

function FormTextArea({
  className = null,
  delay = 300,
  disabled = false,
  error = null,
  inputRef,
  name = null,
  onBlur,
  onChange,
  onFocus,
  placeholder = '',
  readOnly = false,
  rows = 1,
  value = '',
  maxLength = 1000,
  ...restProps
}: TextareaHTMLAttributes<HTMLTextAreaElement> & {
  className?: string;
  delay?: number;
  disabled?: boolean;
  error?: string;
  inputRef?: React.Ref<HTMLTextAreaElement>;
  name?: string;
  onBlur?: (event: React.FocusEvent) => void;
  onChange: (event: React.ChangeEvent, rawValue: string) => void;
  onFocus?: (event: React.FocusEvent) => void;
  placeholder?: string;
  readOnly?: boolean;
  rows?: number;
  value: string;
  maxLength?: number;
}) {
  const [localValue, onChangeHandler] = useDebouncedInput(
    value,
    onChange,
    delay,
  );

  return (
    <div className={`${cbn}__wrapper`}>
      <Tippy
        className={`${cbn}__tippy`}
        arrow={false}
        placement="right"
        visible
        maxWidth="100%"
        interactive
        appendTo={document.body}
      >
        <textarea
          {...omit(restProps, ['debounce', 'stopEditing'])}
          ref={inputRef}
          className={classnames(
            clearClassName(`${cbn}--${name}`),
            cbn,
            className,
            {
              'has-error': error,
              'display-only': readOnly,
            },
          )}
          disabled={disabled}
          readOnly={readOnly}
          name={name}
          onChange={onChangeHandler}
          onBlur={onBlur}
          onFocus={onFocus}
          placeholder={placeholder}
          value={localValue || ''}
          rows={rows}
          maxLength={maxLength}
        />
      </Tippy>
    </div>
  );
}

export default FormTextArea;
